import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  Avatar,
  FormControl,
  Select,
  MenuItem, Switch
} from "@mui/material";
import { Link } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
//Icons
import SearchIcon from "@mui/icons-material/Search";
import CreateIcon from "../Assets/create-icon.svg";
//Srcs
import "../Style/pagestyle.scss";
import { AuthContext } from "../Context/AuthContext";
import FooterPagination from "../Components/Include/FooterPagination";
import EmptyData from "../Components/Include/EmptyData";
import LoadingPage from "../Components/Include/LoadingPage";
import EmptyImage from "../Assets/empty-image.png";
import { UPDATE_MATERIAL_NAME_IS_USE, GET_MATERIAL_NAME_PAGINATION } from "../Schema/MaterialName";
import MaterialNameAction from "../Components/MaterialName/MaterialNameAction"
import CreateMaterialName from "../Components/MaterialName/CreateMaterialName";
import { SelectCategory } from "../Components/Include/DynamicSelect";


export default function MaterialName() {
  const [loading, setLoading] = useState(true);
  const { setAlert } = useContext(AuthContext);


  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [categoryVal, setCategoryVal] = useState({ id: "", title: "" });
  // Switch
  const [status, setStatus] = useState("All");

  const { refetch } = useQuery(GET_MATERIAL_NAME_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      keyword: keyword,
      isUse: status === "All" ? null : status,
      categoryId: categoryVal?.id ? categoryVal?.id : null,
    },
    onCompleted: ({ getMaterialNamePagination }) => {
      setTableData(getMaterialNamePagination?.data);
      setPaginationData(getMaterialNamePagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  // console.log("paginationData",paginationData);


  const [updateMaterialNameIsUse] = useMutation(UPDATE_MATERIAL_NAME_IS_USE, {
    onCompleted: ({ updateMaterialNameIsUse }) => {
      if (updateMaterialNameIsUse?.status) {
        setAlert(true, "success", updateMaterialNameIsUse?.message);

      } else {
        setAlert(true, "error", updateMaterialNameIsUse?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
    },
  });

  const handleUpdateStatus = (id, status) => {
    updateMaterialNameIsUse({
      variables: {
        id: id,
        isUse: status
      }
    })
  }

  // console.log("tabelDataMaterialName:::", tableData);


  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">ការកំណត់</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">ឈ្មោះសម្ភារៈ</Typography>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្វែងរក</Typography>
            <TextField
              placeholder="ស្វែងរកឈ្មោះអ្នកប្រើប្រាស់"
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្ថានភាព</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select value={status} onChange={(e) => setStatus(e.target.value)}>
                <MenuItem value="All">
                  ទាំងអស់
                </MenuItem>
                <MenuItem value={true}>
                  ប្រើប្រាស់
                </MenuItem>
                <MenuItem value={false}>មិនប្រើប្រាស់</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ជ្រើសរើសប្រភេទ</Typography>
            <SelectCategory className="search-field"
              setSelectedVal={setCategoryVal} 
              selectedVal={categoryVal}
              isUse={true}
            />
          </Grid>

          <Grid item xs={6} sm={12} md={12} lg={3} xl={4.8}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
            <CreateMaterialName
              open={open}
              handleClose={handleClose}
            // setRefetch={refetch}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start" width="5%">
                ល.រ
              </TableCell>
              <TableCell className="header-title" width="10%">
                ឈ្មោភាសាខ្មែរ
              </TableCell>
              <TableCell className="header-title" width="10%">
                ឈ្មោះអង់គ្លេស
              </TableCell>

              <TableCell className="header-title" width="7.5%">
                ប្រភេទ
              </TableCell>
              <TableCell className="header-title" width="7.5%">
                ក្រុម
              </TableCell>
              <TableCell className="header-title" width="10%">
                Remark
              </TableCell>
              <TableCell className="header-title" align="center" width="5%">
                Status
              </TableCell>
              <TableCell className="header-title-end" width="20%"></TableCell>
            </TableHead>

            {loading ? (
              <LoadingPage colSpan={9} />
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <EmptyData colSpan={9} />
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className="body-row"
                          key={index}
                        >
                          <TableCell className="body-cell-start">
                            {index + paginationData?.slNo}

                          </TableCell>
                          {/* <TableCell className="body-cell" align="center">
                            <Stack alignItems={`center`}>
                              <Avatar
                                sx={{ width: 40, height: 40 }}
                                // src={row?.imageSrc}
                                src={row?.imageSrc ? `data:image/jpg;base64,${row?.imageSrc}` : EmptyImage}

                              />
                            </Stack>
                          </TableCell> */}

                          <TableCell className="body-cell" >
                            {row?.materialKhName}
                          </TableCell>
                          <TableCell className="body-cell" >
                            {row?.materialEnName}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.categoryId?.categoryKhName}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.groupId?.groupKhName}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.remark}
                          </TableCell>
                          <TableCell className="body-cell" align="center">
                            <Box>
                              <Switch
                                checked={row?.isUse}
                                onChange={() => handleUpdateStatus(row?._id, !row?.isUse)}
                              />
                            </Box>
                          </TableCell>
                          <TableCell className="body-cell-end" align="right">
                            <MaterialNameAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}

        />
      </Box>
    </div>
  );
}
